<template>
  <div class="found-card">
    <div class="found-icon">
      <Icon icon="fluent-mdl2:people-add" class="icon" />
    </div>
    <div class="found-info">
      <span class="count">{{ contactsCount }} contacts found</span>
      <span class="status">Ready to enrich and import</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from "@/components/ui";

defineProps<{
  contactsCount: number;
}>();
</script>

<style scoped>
.found-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--color-primary-light, #f8f7ff);
  border-radius: 10px;
  border: 1px solid rgba(62, 62, 254, 0.15);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

.found-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(62, 62, 254, 0.1);
  border-radius: 10px;
  flex-shrink: 0;
}

.icon {
  font-size: 22px;
  color: var(--color-primary, #3e3efe);
  flex-shrink: 0;
}

.found-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.count {
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--color-primary, #3e3efe);
  letter-spacing: -0.01em;
}

.status {
  font-size: 0.8125rem;
  color: var(--color-text-secondary, #484964);
  font-weight: 500;
}
</style>
